import { serviceAPI } from './api';
import type {
  RecurrenceSeries,
  RecurrenceSeriesResponse,
  CreateRecurrenceSeriesRequest,
  UpdateRecurrenceSeriesRequest,
  UpdateSingleOccurrenceRequest,
  CancelOccurrenceRequest,
  ConflictValidationResponse,
  RecurrenceException,
} from '../types/recurrence';

export const recurrenceApi = {
  // Criar série recorrente
  createSeries: async (data: CreateRecurrenceSeriesRequest): Promise<RecurrenceSeries> => {
    const response = await serviceAPI.post('/recurrence', data);
    return response.data;
  },

  // Buscar série por ID
  getSeries: async (seriesId: string): Promise<RecurrenceSeriesResponse> => {
    const response = await serviceAPI.get(`/recurrence/${seriesId}`);
    return response.data;
  },

  // Atualizar série completa
  updateSeries: async (
    seriesId: string,
    data: UpdateRecurrenceSeriesRequest
  ): Promise<RecurrenceSeries> => {
    const response = await serviceAPI.put(`/recurrence/${seriesId}`, data);
    return response.data;
  },

  // Atualizar ocorrência única
  updateOccurrence: async (
    seriesId: string,
    data: UpdateSingleOccurrenceRequest
  ): Promise<{ message: string; exception: RecurrenceException }> => {
    const response = await serviceAPI.put(`/recurrence/${seriesId}/occurrence`, data);
    return response.data;
  },

  // Cancelar ocorrência(s)
  cancelOccurrence: async (
    seriesId: string,
    data: CancelOccurrenceRequest
  ): Promise<{ message: string }> => {
    const response = await serviceAPI.post(`/recurrence/${seriesId}/cancel`, data);
    return response.data;
  },

  // Buscar ocorrências em período
  getOccurrences: async (
    seriesId: string,
    startDate: string,
    endDate: string
  ): Promise<any[]> => {
    const response = await serviceAPI.get(`/recurrence/${seriesId}/occurrences`, {
      params: { start_date: startDate, end_date: endDate }
    });
    return response.data;
  },

  // Validar conflitos
  validateConflicts: async (
    data: CreateRecurrenceSeriesRequest
  ): Promise<ConflictValidationResponse> => {
    const response = await serviceAPI.post('/recurrence/validate', data);
    return response.data;
  }
};

